import { useState } from 'react';
// 
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import metaMaskGif from "assets/images/others/metaMaskGif.gif"

// ================== you can Add or update FAQs data here =========================
// ========= qs mean Question & ans means answer =================
const faqData = [
    {
        qs: 'How do I get my hands on a WeStreamer NFT?',
        ans: <p>Only on our website (www.westream.app) will you be able to mint a WeStreamer during the pre-sale and public sale. After the sales are completed, we’ll be listed on secondary marketplaces such as OpenSea.</p>
    },
    {
        qs: 'When is the sale?',
        ans: <p>The pre-sale will be taking place on Saturday 30th July at 6PM UTC. The remaining NFTs will go on sale to the general public 48 hours later on Monday 1st August. To find out how you can get access to the pre-sale, drop us a message.</p>
    },
    {
        qs: 'What is the price of a WeStreamer NFT?',
        ans: <p>The first 1000 NFTs will be at a discounted price of 0.1 ETH per mint. After that, the remaining NFTs will cost 0.15 ETH per mint. Prices do not include gas fees.</p>
    },
    {
        qs: 'How many WeStreamers can I buy?',
        ans: <p>During the pre-sale, whitelisted wallets will only be able to purchase a maximum of 1 NFT each. For the public sale, which is first come first served, there will be a limit of 5 NFTs per wallet.</p>
    },
    {
        qs: 'How do I choose an NFT?',
        ans: <p>NFTs are distributed at random in order to keep things fair. Upon purchase, the reveal of your NFT will be in your wallet.</p>
    },
    {
        qs: 'Are there royalties on secondary sales?',
        ans: <p>There will be a creator royalty of 2.5% per sale which will pooled into a marketing wallet. Please keep in mind that secondary marketplaces may also charge sale fees of their own, for example, OpenSea charges 2.5% for every sale.</p>
    },
];


const Faq = () => {
    const [activeFaq, setActiveFaq] = useState(null);
    return (
        <section id="faq">
            <div className="container">
                <div className="sec-heading-wrapper">
                    {/* ================= main heading ==================== */}
                    <h1 className="sec-heading" data-aos="fade-up">FAQs</h1>
                <img src={metaMaskGif} alt=""  width="190" height="140"/>
                </div>
                <div>
                    {faqData.map((data, i) => {
                        return (
                            <div key={i} className={`faq-wrapper ${activeFaq === i ? 'active-faq' : ''}`}>
                                <div data-aos="fade-up" className="faq-qs" onClick={() => setActiveFaq(prev => prev === i ? null : i)}>
                                    <h6>{data.qs}</h6><span className="faq-arrow"><ArrowForwardIosIcon /></span>
                                </div>
                                <div className="faqs-answer text-white">
                                    {data.ans}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}

export default Faq
